import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService, AuthRole } from '../../../modules/auth';
import { ManageBrokersTab } from '@app/modules/trading/modules/manage-brokers/manage-broker.enums';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard  {

    constructor(
        private router: Router,
        private authService: AuthService,
        private activatedRoute: ActivatedRoute
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.isOauthCallback(state.url)) { return true; }
        if (this.isMultiBrokerCallback(state.url)) { return true; }
        return this.isValid();
    }
    canLoad(
        route: Route,
        segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
        if (this.isOauthCallback(segments.join('/'))) { return true; }
        if (this.isMultiBrokerCallback(segments.join('/'))) { return true; }
        return this.isValid();
    }

    isOauthCallback(url: string) {
        // We can link account from dashboard so we need to allow oAuth callback even if user is already loggedin
        return url.includes('callback/');
    }

    isMultiBrokerCallback(url: string) {
        if (url.includes('/verify-otp') || url.includes('/add-phone')) { 
            if (this.authService.userInfo && this.authService.userInfo.access) {
                return true;
            } else {
                return false;
            }
        }
    }

    /**
     * Only Allow opening authentication pages if user has not logged in.
     * If authenticated redirect to dashboard instead.
     *
     * @returns true if user is not logged in.
     */
    isValid() {
        if (this.authService.isAuthenticated) {
            this.router.navigate(['/trading/dashboard']);
            if (this.authService.accessTokenObj.role === AuthRole.USER) {
                this.router.navigate(['/trading/dashboard']);
            } else if (this.authService.accessTokenObj.role === AuthRole.BUSINESSPARTNER ||  this.authService.accessTokenObj.role === AuthRole.SUPERDEALER) {
                this.router.navigate(['/affiliate']);
            } else {
                this.router.navigate(['/admin']);
            }
            return false;
        }
        return true;
    }
}
